import API from "../../../../services/api-request";
import state from "../../../../config/valtio/store";
import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row, Table, message } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import dayjs from "dayjs";
import FilterMenu from "./filter-menu";
import AddCompany from "./modal-add-company";
import EditCompany from "./modal-edit-company";
import "../../../../assets/css/style-table.css";

const { confirm } = Modal;

const Companies = () => {
  const [dataCompany, setDataCompany] = useState([]);
  const [dataCompanyFilter, setDataCompanyFilter] = useState([]);
  const [selectedData, setSelectedData] = useState({});

  // Edit Modal Variable Function
  const [showEdit, setShowEdit] = useState(false);
  const onShowEdit = (val) => {
    setShowEdit(val);
  };

  // Add Modal Variable & Function
  const [showAdd, setShowAdd] = useState(false);
  const onShowAdd = (val) => {
    setShowAdd(val);
  };

  const getCompany = async () => {
    state.LOADING = true;

    await API.Get("company")
      .then((result) => {
        setDataCompany(result?.data);
        setDataCompanyFilter(result?.data);
      })
      .catch((err) => {
        console.error(err);
        message.info("Failed Fetch Company Data!");
      });

    state.LOADING = false;
  };

  useEffect(() => {
    getCompany();
  }, []);

  // Delete Confirm
  const showDeleteConfirm = (data) => {
    confirm({
      title: `Delete ${data.name}`,
      icon: <ExclamationCircleFilled />,
      content: `Are you sure delete ${data.name}?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        API.Delete(`company/${data.id}`)
          .then(() => {
            message.success("Company has been deleted");
          })
          .catch((err) => {
            message.info("Failed delete Company");
            console.error(err);
          })
          .finally(() => {
            getCompany();
          });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const columns = [
    {
      title: "No.",
      key: "id",
      width: 60,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name - b.name,
      render: (name) => (name ? name : "-"),
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      sorter: (a, b) => a.address - b.address,
      render: (address) => (address ? address : "-"),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a, b) => a.created_at - b.created_at,
      render: (created_at) =>
        created_at ? dayjs(created_at).format("YYYY-MM-DD HH:mm:ss") : "-",
    },
    {
      title: "Updated At",
      dataIndex: "updated_at",
      key: "updated_at",
      sorter: (a, b) => a.updated_at - b.updated_at,
      render: (updated_at) =>
        updated_at ? dayjs(updated_at).format("YYYY-MM-DD HH:mm:ss") : "-",
    },
    {
      title: "Action",
      key: "action",
      width: 180,
      render: (data) => {
        return (
          <Row align="middle" gutter={[8, 8]}>
            <Col>
              <Button
                type="primary"
                onClick={() => {
                  setSelectedData({ ...data });
                  onShowEdit(true);
                }}
              >
                Edit
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                danger
                onClick={() => {
                  showDeleteConfirm(data);
                }}
              >
                Delete
              </Button>
            </Col>
          </Row>
        );
      },
    },
  ];

  const onSearch = async (val) => {
    let data = dataCompany.filter((company) =>
      company.name.toLowerCase().includes(val.toLowerCase())
    );

    setDataCompanyFilter(data);
  };

  const onClear = async (val) => {
    getCompany();
  };

  const rowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };

  return (
    <>
      <FilterMenu onShowAdd={onShowAdd} onSearch={onSearch} onClear={onClear} />

      {/* Company Table */}
      <Table
        rowKey="id"
        columns={columns}
        dataSource={dataCompanyFilter}
        rowClassName={rowClassName}
        scroll={{
          x: 1000,
        }}
        size="large"
      />

      {/* Modal Add Company */}
      <div
        style={{ display: "flex", justifyContent: "flex-end", margin: "8px 0" }}
      >
        <AddCompany
          showAdd={showAdd}
          onShowAdd={onShowAdd}
          onGetCompany={getCompany}
        />
      </div>

      {/* Modal Edit Company */}
      <EditCompany
        showEdit={showEdit}
        onShowEdit={onShowEdit}
        onGetCompany={getCompany}
        selectedData={selectedData}
      />
    </>
  );
};

export default Companies;
